import { render, staticRenderFns } from "./fillupbalans.vue?vue&type=template&id=5034bf96&scoped=true&"
import script from "./fillupbalans.vue?vue&type=script&lang=js&"
export * from "./fillupbalans.vue?vue&type=script&lang=js&"
import style0 from "./fillupbalans.vue?vue&type=style&index=0&id=5034bf96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034bf96",
  null
  
)

export default component.exports